var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4.36025C0 5.40994 0.154639 7.02484 1.54639 8.47826C2.7835 9.77019 6.88144 12.677 7.03608 12.8385C7.19072 12.9193 7.34536 13 7.5 13C7.65464 13 7.80928 12.9193 7.96392 12.8385C8.11856 12.677 12.2165 9.85093 13.4536 8.47826C14.8454 7.02484 15 5.40994 15 4.36025C15 1.93789 13.1443 0 10.8247 0C9.58763 0 8.35052 0.726708 7.57732 1.85714C6.80412 0.726708 5.56701 0 4.17526 0C1.93299 0 0 1.93789 0 4.36025Z","fill":"black","fillOpacity":"0.2"}));
}

Heart.defaultProps = {"width":"12","height":"10","viewBox":"0 0 15 13","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
